import { IconOptions } from 'primereact/utils';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const TruckGray = (options: IconOptions) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...options.iconProps}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.5957 3.01081C1.87849 3.08444 1.28188 3.57281 1.07288 4.25731C1.002 4.4895 1 4.63228 1 9.4506V14.4052H1.85003H2.70005L2.7238 14.6024C2.76908 14.9786 2.82634 15.177 2.98672 15.5133C3.17583 15.91 3.37604 16.1661 3.70898 16.4374C4.16562 16.8095 4.71142 17.0006 5.31775 17.0005C6.07508 17.0004 6.68657 16.7331 7.20699 16.1746C7.60562 15.7469 7.85306 15.2066 7.89266 14.6775L7.91307 14.4052H10.5H13.0869L13.1073 14.6775C13.1469 15.2066 13.3944 15.7469 13.793 16.1746C14.3134 16.7331 14.9249 17.0004 15.6823 17.0005C16.0908 17.0005 16.4256 16.9272 16.7833 16.7591C17.6034 16.374 18.1597 15.5703 18.2762 14.6024L18.2999 14.4052H19.15H20V12.1952V9.98529L18.7152 8.25098L17.4305 6.51663H16.1365H14.8425L14.8329 4.76049L14.8232 3.00435L8.77441 3.00093C5.44756 2.99902 2.66714 3.00349 2.5957 3.01081ZM17.8184 8.92237L18.6612 10.0101H16.7515H14.8418V8.92075V7.83138L15.9087 7.833L16.9756 7.83465L17.8184 8.92237ZM5.82875 13.1922C6.03337 13.2847 6.28341 13.5054 6.40565 13.7014C6.80495 14.3417 6.5356 15.2346 5.84689 15.5538C5.33386 15.7916 4.74949 15.6648 4.3633 15.2321C4.1609 15.0054 4.07039 14.7761 4.05162 14.4427C4.01974 13.8777 4.31832 13.4059 4.85203 13.178C5.02971 13.1021 5.1109 13.0898 5.36035 13.1012C5.55558 13.1101 5.71597 13.1413 5.82875 13.1922ZM16.2148 13.2076C16.4745 13.3304 16.7191 13.5776 16.8422 13.8417C16.9719 14.1199 16.9798 14.6309 16.8586 14.8981C16.4911 15.7083 15.4633 15.9234 14.8108 15.3267C14.201 14.7689 14.3082 13.719 15.0208 13.2711C15.3498 13.0643 15.8548 13.0374 16.2148 13.2076Z'
        fill='#90A4AE'
        fillOpacity='0.8'
      />
    </svg>
  );
};

export default TruckGray;
